<template lang="html">
    <div id="page__luw-search" class="toolbar-search">
        <z-select
            v-model="filter.type" light
            name="filter_storages-type"
            id="filter_storages-type"
            v-on:input="onFilter"
        >
            <option value="" selected> Тип расчета (любой) </option>
            <option v-bind:value="1"> По весу </option>
            <option v-bind:value="2"> По объёму </option>
        </z-select>

        <z-select
            v-model="filter.stock_id" light
            name="filter_storages-stock_id"
            id="filter_storages-stock_id"
            v-on:input="onFilter"
        >
            <option value="" selected>Склад (любой)</option>
            <option v-for="stock in stocks" v-bind:key="`storages-toolbar-item-stock-${stock.id}`" v-bind:value="stock.id">{{ stock.name }}</option>
        </z-select>

        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-bind:disabled="!hasFilter" v-on:click="onReset"></z-icon-button>
    </div>
</template>
<script>
    import ZIconButton from '@/components/ZIconButton.vue';
    import ClickOutside from 'vue-click-outside';
    import ZSelect from '@/components/ZSelect';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: { ZIconButton, ZSelect, ZInputAutocomplete},
        directives: {ClickOutside},
        data() {
            return {
                loading: false,
                stocks: [],
                filter: {
                    stock_id: '',
                    type: ''
                },
                filterDefault: {
                    stock_id: '',
                    type: ''
                },
            }
        },
        created() {
            this.getStocks();
            this.resolveQueryFilter();
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            },
        },
        watch: {
            'filter.city_id'(newVal, oldVal) {
                if (oldVal != newVal) this.onFilter();
            },
            'filter.zone_id'(newVal, oldVal) {
                if (oldVal != newVal) this.onFilter();
            }
        },
        methods: {
			getStocks() {
				this.$store.dispatch('stock/getStocks', {all: true}).then(r => {
					if (!r || !r.data) return;
					this.stocks = Object.assign({}, r.data);
				}).finally(() => this.$store.commit('hideProgressBar', 'load-storage-card'));
			},            
             /**
             * Фильрация
             */
            doFilter() {
                this.$nextTick(() => {
                    let filter = {};
                    Object.keys(this.filter).map(key => {
                        if (this.filter[key]) filter[key] = this.filter[key];
                    });

                    this.$router.push({ name: this.$route.name, params: this.$route.params, query: { filter: JSON.stringify(filter)}});
                    this.$root.$emit('refresh-table', 'storagesprice');
                });
            },
            /**
             * Подставлене фильтра при перезагрузки
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            /**
             * Фильтрация
             */
            onFilter() {
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'storagesprice');
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query   = Object.assign({}, this.$route.query);
                delete query.filter;
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query:  Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'storagesprice');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// StoragesToolbar.vue?11f9bdb6